import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { useEmailStats } from 'automation-ui-action-features/actions/email/hooks/emailStatsHooks';
import DetailsPopoverBulletPoint from 'automation-ui-action-features/action-details/DetailsPopoverBulletPoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EmailActionPopoverStats({
  action,
  flowObjectTypeId
}) {
  const {
    contentId
  } = action.metadata;
  const {
    clickThroughRatio,
    goalsMet
  } = useEmailStats({
    flowId: action.flowId,
    actionId: action.actionId,
    contentId: contentId,
    flowObjectTypeId
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [clickThroughRatio !== undefined && /*#__PURE__*/_jsx(DetailsPopoverBulletPoint, {
      iconName: "onlineRegistration",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.email.stats.clickThroughRate",
        options: {
          clickRate: /*#__PURE__*/_jsx(FormattedPercentage, {
            value: clickThroughRatio * 100,
            precision: 2
          })
        }
      })
    }), goalsMet !== undefined && /*#__PURE__*/_jsx(DetailsPopoverBulletPoint, {
      iconName: "goal",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-action-features.action-features.email.stats.goalsMet",
        options: {
          count: goalsMet
        }
      })
    })]
  });
}